export default "__VITE_ASSET__C$gKF0ys__"